import { render } from "./CategorySelectionModal.vue?vue&type=template&id=19a4048d"
import script from "./CategorySelectionModal.vue?vue&type=script&lang=js"
export * from "./CategorySelectionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__